const systemInitialState = {
    errorMenuCustomer: 1,
    vps: false,
    vps_gpu: false,
    nat_vps: false,
    vps_us: false,
    cloudServer: false,
    hosting: false,
    proxy: false,
    menuProduct: {},
    isMenuCustomer: false,
    menuCustomer: {
        vps: false,
        vps_us: false,
        proxy: false,
        cloud_server: false,
        hosting_cpanel: false,
    }
}
const systemReducer = (state = systemInitialState, action) => {
    switch (action.type) {
        case 'updateMenuProduct':
            return { ...state, vps: action.item.vps, vps_gpu: action.item.vps_gpu, nat_vps: action.item.nat_vps,
                cloudServer: action.item.cloudServer,
                hosting: action.item.hosting, vps_us: action.item.vps_us, proxy: action.item.proxy
            }
        case 'updateMenu':
            return { ...state, errorMenuCustomer: 0, menuProduct: action.item }
        case 'updateMenuCustomer':
            return { ...state, isMenuCustomer: true, menuCustomer: action.item }
        default:
            return state
    }
}

export default systemReducer;